import api from './index';

export function fetchDetectionManagePage(params) {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('用户未登录，token 不存在');
    }
    return api.post('/web/detection-manage/page', params, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export function deleteScheduledExport(id) {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('用户未登录，token 不存在');
    }
    return api.delete(`/web/detection-manage/scheduled-export/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export function exportDetectionManage(params) {
    return api.post('/web/detection-manage/export', params, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        transformResponse: [(data) => {
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                return data;
            }
            return data instanceof Blob ? data : new Blob([data]);
        }]
    });
}

export function listScheduledExports() {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('用户未登录，token 不存在');
    }
    return api.get('/web/detection-manage/scheduled-exports', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export function triggerScheduledExport() {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('用户未登录，token 不存在');
    }
    return api.post('/web/detection-manage/scheduled-export/trigger', {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export function downloadScheduledExport(fileName) {
    return api.get('/web/detection-manage/scheduled-export/download', {
        params: { fileName },
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        transformResponse: [(data) => {
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                return data;
            }
            return data instanceof Blob ? data : new Blob([data]);
        }]
    });
}
